import type { GetMeterInstanceKeysResponse } from '@weft/api-definition';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useMeterInstanceKeys(productId: string, customerId: string, options?: Omit<UseQueryOptions<GetMeterInstanceKeysResponse, unknown, GetMeterInstanceKeysResponse, string[]>, 'queryKey' | 'queryFn'>) {
  const meterInstanceKeysQuery = useQuery(
    ['meter-instance-keys', productId],
    async () => {
      const api = getPrivateApi();
  
      return api.getMeterInstanceKeys({ productId, customerId });
    },
    options,
  );

  return meterInstanceKeysQuery;
}